import React, { useEffect, useState } from 'react';

function Preloader() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const hidePreloader = () => setLoaded(true);

        if (document.readyState === 'complete') {
            // Sayfa zaten yüklendiyse hemen gizle
            hidePreloader();
        } else {
            // Yüklenmesini bekle
            window.addEventListener('load', hidePreloader);
        }

        return () => {
            window.removeEventListener('load', hidePreloader);
        };
    }, []);

    return (
        <div className={`preloader ${loaded ? 'hide' : ''}`}>
            <div className="loader-p" />
        </div>
    );
}

export default Preloader;
